export const TELOS_CHAIN_IDS = ['40', '41', '331'];
export const TELOS_NETWORK_NAMES = ['telos-evm', 'telos-evm-testnet', 'telos-zkevm-testnet'];
